<div class="modal-container" [ngClass]="{ 'hidden-print-area': hideContent }">
  <div class="modal-report-header">

    <button (click)="downloadPdf()" type="button" id="download-button">
      <img src="../../../assets/icons/datatable-cloud-download.svg" alt="Descargar" loading="lazy" />
      <span>{{ 'download' | translate }}</span>
    </button>
  </div>

  <app-report-content [details]="detailsData" [brandingLogo]="logoUrl" [showPDF]="showPDF"
    [paginatedPickupImages]="paginatedPickupImages" [paginatedDropoffImages]="paginatedDropoffImages"
    [isEconomicReport]="isEconomicReport" [orderHash]="orderHash"></app-report-content>
</div>